import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AccessDeniedComponent } from "../session/access-denied/access-denied.component";
import { DashboardGuard } from "../session/guards/dashboard.guard";
import { LoggedInGuard } from "../session/guards/logged-in.guard";
import { DashboardsComponent } from "./dashboards/dashboards.component";
import { EmbeddedDashboardComponent } from "./embedded-dashboard/embedded-dashboard.component";
import { HomeComponent } from "./home/home.component";
import { InspectionsComponent } from "./inspections/inspections.component";
import { ItemSearchResultComponent } from "./inspections/item-search-result/item-search-result.component";
import { NewInspectionComponent } from "./new-inspection/new-inspection.component";
import { TimesheetActivitiesComponent } from "./timesheet-activities/timesheet-activities.component";

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
    canActivate: [LoggedInGuard],
    children: [
      {
        path: "",
        component: InspectionsComponent,
      },
      {
        path: "resources",
        loadChildren: () =>
          import("../resources/resources.module").then(
            (m) => m.ResourcesModule,
          ),
      },
      {
        path: "dashboards",
        component: DashboardsComponent,
        canActivate: [LoggedInGuard, DashboardGuard],
      },
      {
        path: "dashboard",
        component: EmbeddedDashboardComponent,
        canActivate: [LoggedInGuard],
      },
      {
        path: "timesheet-activities",
        component: TimesheetActivitiesComponent,
        canActivate: [LoggedInGuard],
      },
      {
        path: "settings",
        loadChildren: () =>
          import("../settings/settings.module").then((m) => m.SettingsModule),
      },
      {
        path: "about",
        loadChildren: () =>
          import("../about/about.module").then((m) => m.AboutModule),
      },
      {
        path: "access-denied",
        component: AccessDeniedComponent,
      },
      {
        path: "item-search-result",
        component: ItemSearchResultComponent,
        canActivate: [LoggedInGuard],
      },
    ],
  },
  {
    path: "details",
    loadChildren: () =>
      import("./details/inspection-details.module").then(
        (m) => m.InspectionDetailsModule,
      ),
  },
  {
    path: "new-inspection",
    component: NewInspectionComponent,
    canActivate: [LoggedInGuard],
  },
  {
    path: "new-inspection/:id",
    component: NewInspectionComponent,
    canActivate: [LoggedInGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InspectionRoutingModule {}
